// Shared nav wiring for the finance/revenue report launchers (CD-5241). Every
// report card opens its in-app report the same way: link_click(component, title,
// NAV_ICON, 0, 0, url). This centralises the icon and the arg convention so the
// per-page section builders don't each re-declare them.
export const REPORT_NAV_ICON = 'fa-solid fa-money-bill-wave';

// linkClick: the redux link_click action. Returns an open(link, title, url) helper.
export const makeReportOpener = (linkClick) => (link, title, url) => linkClick(link, title, REPORT_NAV_ICON, 0, 0, url);
